import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { sortBy, startCase } from "lodash";

const RecipeList = ({
  recipes,
  uid,
  onlyFavorites,
  favorites,
  toggleFavorite,
}) => {
  const renderRecipes = (recipes) => {
    const newRecipes = sortBy(recipes, (recipe) => startCase(recipe.title));
    if (onlyFavorites) {
      const favesOnly = newRecipes.filter((recipe) =>
        favorites.includes(recipe._id)
      );

      if (!favesOnly.length) {
        return <h3>You don't have any faves :-(</h3>;
      }

      return favesOnly.map((recipe) => {
        return (
          <div key={recipe.title} className="recipeCard">
            <div className="adminList">
              <div
                className="heart-filled"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <svg
                  width="1em"
                  height="1em"
                  viewBox="0 0 16 16"
                  onClick={() => toggleFavorite(recipe._id, false)}
                  className="bi bi-heart-fill"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                  />
                </svg>

                <h4 className="viewTitle" style={{ marginLeft: "0.5em" }}>
                  <NavLink to={`/cookbook/recipe/${recipe._id}`}>
                    {recipe.title}
                  </NavLink>
                </h4>
              </div>
              <h4 className="viewTitle">
                <NavLink to={`/cookbook/profile/${uid}/recipe/${recipe._id}`}>
                  Edit
                </NavLink>
              </h4>
            </div>
          </div>
        );
      });
    } else {
      return newRecipes.map((recipe) => {
        return (
          <div key={recipe.title} className="recipeCard">
            <div className="adminList">
              <div
                className="heart-filled"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {favorites.includes(recipe._id) ? (
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    onClick={() => toggleFavorite(recipe._id, false)}
                    className="bi bi-heart-fill"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                    />
                  </svg>
                ) : (
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 16 16"
                    onClick={() => toggleFavorite(recipe._id, true)}
                    className="bi bi-heart"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"
                    />
                  </svg>
                )}

                <h4 className="viewTitle" style={{ marginLeft: "0.5em" }}>
                  <NavLink to={`/cookbook/recipe/${recipe._id}`}>
                    {recipe.title}
                  </NavLink>
                </h4>
              </div>
              <h4 className="viewTitle">
                <NavLink to={`/cookbook/profile/${uid}/recipe/${recipe._id}`}>
                  Edit
                </NavLink>
              </h4>
            </div>
          </div>
        );
      });
    }
  };

  return (
    <div className="results">
      <div className="recipeCard">
        <p className="formTitle">Your Recipes</p>
        <div className="recipePageTitle zigzag" />
      </div>
      <div className="listAllMeals">{renderRecipes(recipes)}</div>
    </div>
  );
};

RecipeList.propTypes = {
  recipes: PropTypes.array.isRequired,
  selectRecipe: PropTypes.func,
  uid: PropTypes.string,
  favorites: PropTypes.array,
  toggleFavorite: PropTypes.func,
};

export default RecipeList;
